import styled from 'styled-components/macro'
import { rem} from '../../utils/styles'
import H1 from '../H1'

const CallToActionTitle = styled(H1).attrs({
  size: 'small'
})`
  margin: ${rem(40)} 0;
`

export default CallToActionTitle
